import React from 'react';
import ArrowRight from 'src/assets/images/iconsMvpApp/arrow-right.svg';
import { t } from 'i18next';

export const MvpArrowRight = () => {
  return (
    <img
      src={ArrowRight}
      aria-label={t('Open')}
      style={{
        width: '24px',
        height: '24px',
      }}
    />
  );
};
